export default function formatRegnumber(regNumber: string): string {
  if (!regNumber) {
    return ''
  }
  return regNumber.replace(/([^\d\s%])(\d)/g, '$1 $2').toUpperCase()
}
